// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSolanamainnet } from "../../../icons/mono/build/icon-solanamainnet.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SolanamainnetIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSolanamainnet.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SolanamainnetIcon.displayName = 'SolanamainnetIcon';
}

export default SolanamainnetIcon;